import { Link } from "react-router-dom";
import { Phone, MapPin } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, ADDRESS_LINE1, ADDRESS_LINE2 } from "@/lib/campaign";
import { track } from "@/lib/track";

export const Footer = ({ variant }) => (
  <footer data-testid="campaign-footer" className="bg-[var(--brand-navy-deep)] text-white">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12 grid gap-10 sm:grid-cols-3">
      <div>
        <img src="/images/logo.png" alt="All-In Precision Wellness" className="h-20 w-20 object-contain bg-white rounded-full p-1" />
        <p className="mt-4 text-sm text-white/70 leading-relaxed">
          Physician-led menopause, perimenopause, and functional medicine care in Easton, Pennsylvania.
        </p>
      </div>
      <div>
        <h3 className="font-serif-brand text-lg mb-3 text-[var(--brand-gold)]">Contact</h3>
        <a
          data-testid="footer-call-link"
          href={PHONE_TEL} data-call-location="footer"
          onClick={() => track(variant, "call_click")}
          className="flex items-center gap-2 text-white hover:text-[var(--brand-gold)] transition-colors"
        >
          <Phone className="h-4 w-4" aria-hidden="true" /> {PHONE_DISPLAY}
        </a>
        <p className="mt-3 flex items-start gap-2 text-sm text-white/70">
          <MapPin className="h-4 w-4 mt-0.5 shrink-0" aria-hidden="true" />
          <span>
            {ADDRESS_LINE1}
            <br />
            {ADDRESS_LINE2}
          </span>
        </p>
      </div>
      <div>
        <h3 className="font-serif-brand text-lg mb-3 text-[var(--brand-gold)]">Practice</h3>
        <ul className="space-y-2 text-sm">
          <li>
            <a
              data-testid="footer-main-site-link"
              href="https://allinprecisionwellness.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/80 hover:text-[var(--brand-gold)] transition-colors"
            >
              allinprecisionwellness.com
            </a>
          </li>
          <li>
            <Link
              data-testid="footer-privacy-link"
              to="/privacy"
              className="text-white/80 hover:text-[var(--brand-gold)] transition-colors"
            >
              Privacy and data practices
            </Link>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <p className="max-w-6xl mx-auto px-4 sm:px-6 py-4 text-xs text-white/50">
        &copy; {new Date().getFullYear()} All-In Precision Wellness. All-In Precision Wellness is a
        private-pay practice and does not accept insurance.
      </p>
    </div>
  </footer>
);
